module.exports = __webpack_public_path__ + "img/ass3.ae783f9b.jpg";